module.exports = {
  "version": "0.27.2"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/axios/lib/env/data.js
// module id = 147
// module chunks = 0